import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";

const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.title)
      items.push({ text: "Title", value: item.title, type: "text" });

   
    if (item.sortOrder !== undefined && item.sortOrder !== null)
      items.push({ text: "Sort Order", value: item.sortOrder, type: "number" });
 if (item.boxType)
      items.push({ text: "Box Type", value: item.boxType, type: "text" });
    if (item.priceBadgeText)
      items.push({
        text: "Price Badge Text",
        value: item.priceBadgeText,
        type: "text",
      });

    if (item.priceBadgeColor)
      items.push({
        text: "Price Badge Color",
        value: item.priceBadgeColor,
        type: "color",
      });

    if (item.specialOfferText)
      items.push({
        text: "Special Offer Text",
        value: item.specialOfferText,
        type: "text",
      });

    if (item.specialOfferTextColor)
      items.push({
        text: "Special Offer Text Color",
        value: item.specialOfferTextColor,
        type: "color",
      });

    return items;
  };

  return (
    <Card className="item mb-2 borderCream position-relative">
      {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        ></div>
      )}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="checkboxCol me-2 mt-2"></div>

            <div className="ms-1 me-2">
              <i className="fas fa-file pt-1 position-relative cartIcon ">
                {(item.status === "0" || item.status === 0) && (
                  <i className="fas fa-ban position-absolute  mb-2 banned3"></i>
                )}
              </i>
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.title}
              </span>

              <span className="">
                <span className="text-custom-4 mt-1 small  text-boldmt-1">
                  {item.daysInPlan} days meals
                </span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div
          className="card-tools endColumn mb-1 pt-1"
          style={{ zIndex: 101, position: "relative" }}
        >
          <div>
            {item.galleryAlbumId && (
              <span className="badge badge-warning me-1 text-dark">
                Attached Gallery
              </span>
            )}
            {(item.showOnHomePage === "1" || item.showOnHomePage === 1) && (
              <span className="badge homePageShow me-1 text-white">
                Showing on Home Page
              </span>
            )}
            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="">
            {/* <StatsListing heading="Cart" clickable items={getCart()} /> */}
            <StatsListing items={getItems()} />
          </Col>
        </Row>
        <Row>
          <Col className="">
            {item.description && (
              <Alert className="alert-custom-3 mb-1 d-flex  flex-wrap p-1 font-small">
                <strong className="me-1 mt-1 text-custom-1">
                  Description:
                </strong>
                <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                  <span
                    className="font-small text-normal text-custom-1 html"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></span>
                </div>
              </Alert>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Item;
